import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import axios from 'axios';
import AdminRoute from "./_helpers/AdminRoute";
//import Start from "./Pages/Start/Start";
import Getcertified from "./Pages/Getcertified/Getcertified";
import BusinessBenefits from "./Pages/BusinessBenefits/BusinessBenefits";
import Aboutus from "./Pages/Aboutus/Aboutus";
import Home from "./Pages/Home/Home";
import Events from "./Pages/Events/Events";
import Material from "./Pages/Material/Material";
import Contact from "./Pages/Contact/Contact";
import Standard from "./Pages/Standard/Standard";
import Community from "./Pages/Community/Community";
import CodeOfConduct from "./Pages/CodeOfConduct/CodeOfConduct";

// Admin Pages
import AdminLogin from "./Admin/Pages/Login/Login";
import AdminDash from "./Admin/Pages/Dashboard/Dashboard";
import AdminEvents from "./Admin/Pages/Events/Events";
import AdminAddEvent from "./Admin/Pages/Events/AddEvent";
import AdminEditEvent from "./Admin/Pages/Events/EditEvent";
import AdminMarketingEvents from "./Admin/Pages/MarketingEvents/MarketingEvents";
import AdminAddMarketingEvent from "./Admin/Pages/MarketingEvents/AddEvent";
import AdminEditMarketingEvent from "./Admin/Pages/MarketingEvents/EditEvent";

import AdminRegistrations from "./Admin/Pages/Registrations/Registrations";
import AdminEditRegistration from "./Admin/Pages/Registrations/EditRegistration";

import "bootstrap/dist/css/bootstrap.min.css";
import "./css/index.css";
import "./css/responsive.css";

var APP_API = "https://api.certifiedintegrator.com/api/1.0";
var domains = ["certifiedintegrator.se", "certifiedintegrator.com", "www.certifiedintegrator.se", "www.certifiedintegrator.com"];
if (domains.includes(window.location.hostname)) {
    APP_API = process.env.REACT_APP_API;
}

axios.defaults.baseURL = APP_API;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

class App extends Component {

    render() {
        return (
            <div className="App">
                <Router>
                    <Switch>
                        <Route exact path="/" component={Home}/>
                        <Route exact path="/get-certified" component={Getcertified}/>
                        <Route exact path="/business-benefits" component={BusinessBenefits}/>
                        <Route exact path="/aboutus" component={Aboutus}/>
                        <Route exact path="/events" component={Events}/>
                        <Route exact path="/contacts" component={Contact}/>
                        <Route exact path="/material" component={Material}/>
                        <Route exact path="/standard" component={Standard}/>
                        <Route exact path="/community" component={Community}/>
                        <Route exact path="/code-of-conduct" component={CodeOfConduct}/>

                        <Route exact path="/admin/login" component={AdminLogin}/>
                        <AdminRoute path="/admin/dashboard" component={AdminDash}/>
                        <AdminRoute path="/admin/events" component={AdminEvents}/>
                        <AdminRoute path="/admin/event/add" component={AdminAddEvent}/>
                        <AdminRoute path="/admin/event/edit/:eventID" component={AdminEditEvent}/>

                        <AdminRoute path="/admin/marketing-events" component={AdminMarketingEvents}/>
                        <AdminRoute path="/admin/marketing-event/add" component={AdminAddMarketingEvent}/>
                        <AdminRoute path="/admin/marketing-event/edit/:eventID" component={AdminEditMarketingEvent}/>

                        <AdminRoute path="/admin/registrations" component={AdminRegistrations}/>
                        <AdminRoute path="/admin/registration/edit/:regID" component={AdminEditRegistration}/>
                        <Route component={NotFound}/>
                    </Switch>
                </Router>
            </div>
        );
    }
}

const NotFound = () => <div className="nomatch"/>;
export default App;
